import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'xgimi-ui/Container';
import images from '../../../assets/images';
import StoreComponent, { mapStateToProps } from '../../../appComponents/Store';

import s from './.module.scss';

interface Props {
}

interface States {
}

/**
 * 反馈成功
 */
class Component extends StoreComponent<Props, States> {
  state: States = {
  };

  constructor(props: Props) {
    super(props, { languageKey: 'page.feedback', titleKey: 'title' });
  }
  componentDidMount() {
  }

  render(): React.ReactNode {
    return (
      <Container className={s.container} isMobile={true}>
        <div className={s.top}>
          <img src={images.success} alt="success" className={s.image} width={88} height={88}/>
          <div className={s.success}>反馈已提交</div>
          {/* <Button
            color={'#000004'}
            disableElevation={true}
            className={s.button}
            onClick={() => this.history.push('/feedback')}
          >
            回到帮助与反馈
          </Button> */}

        </div>
        <Link replace className={s.history} to="/feedback/history">{this.t('gotoHistory')}</Link>
      </Container>
    );
  }
}

export default connect(mapStateToProps)(Component);
